var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._g(_vm._b({staticClass:"vcita-switch",class:{
    'is-active': _vm.$attrs.value,
  },attrs:{"input-value":_vm.$attrs.value,"color":_vm.brandBgColor,"hide-details":'auto',"inset":""},on:{"change":val => _vm.$emit('input', Boolean(val))}},'v-switch',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }